import { assert } from 'cadenza/utils/custom-error';
import type { OlapPivotTable } from 'cadenza/result-table/olap-pivot-table';
import { ResultTablePlugin } from 'cadenza/result-table/result-table-plugin';

export abstract class OlapPivotTablePlugin extends ResultTablePlugin {

  override get table () {
    const olapPivotTable = this.parentElement;
    assert(olapPivotTable, 'Plugin not yet initialized by result table');
    return olapPivotTable as OlapPivotTable;
  }

}
